import React from 'react';
import CommonFunctions from '../RegCommon/CommonFunctions';
import Select from 'react-select';
import { Input } from 'reactstrap';

/*
    
    data5: item id
    data1: item order
    data3: dropdownprice ?? 
    data4: 
            multiselect - for multiple select
            blank - for single select

    data2: Has sub-items

            "Select" is the first item in the droopdown
            Select~~sub item title==sub item id~~sub item title==sub item id
            Select~~June 2022==6080~~July 2022==6090~~August 2022==6100 (Select~~sub item name==data5field as id ~~)
    
*/

class RegItemdropdown extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            regitem: props.regitem,
            groupname: props.groupname,
            disableregitem: props.disableregitem,
            signupsremaining: props.signupsremaining,
            selectedregdropdownitem: '',
        }
    }

    render() {
        if (CommonFunctions.isUserLoggedin()) {
            return (
                <div>
                    {this.renderRegDropdownOptionsInUpdate(this.state.regitem, this.state.groupname)}
                </div>
            )
        }
        else {
            return (
                <div>
                    {this.renderRegDropdownOptions(this.state.regitem, this.state.groupname)}
                </div>
            );
        }
    }

    renderRegDropdownOptionsInUpdate(item, groupname) {
        if (global.$loggedinuserregitems != null) {
            var regitems = global.$loggedinuserregitems

            var dropdownOptions = item.data2;
            dropdownOptions = dropdownOptions.split("~~");

            // this is for Registration update and if you are already registered for this item
            if (regitems.includes(item.name)) {
                regitems = regitems.split(",");

                // Filter and get all the selected dropdown values for this reg dropdown
                var selectedmultiplevalues = [];
                regitems.map(regitem => {
                    if (regitem.includes(item.name)) {
                        //console.log(regitem);
                        var eachitem = regitem.split(" - ");
                        eachitem.map((selecteditem) => {
                            selectedmultiplevalues.push(selecteditem);
                        })
                    }
                })
                var selecteditemnames = [];

                // This is to handle multiselection dropdown
                if (item.data4 == "multiselect") {
                    let dropdownItems = dropdownOptions.map(dropdownoption => {
                        var [title, id] = dropdownoption.split("==")
                        //console.log(title, id);

                        // Using this variable to check that reopdown items are available or soldout
                        var disabled = false;
                        global.$regdropdownoptions.map(dropdownitem => {
                            //console.log(dropdownitem);
                            if (dropdownitem.name == title && dropdownitem.data5 == id) {
                                var maxsignups = dropdownitem.maxsignups;
                                var currentsignups = dropdownitem.currentsignups;

                                if ((Number(maxsignups) - Number(currentsignups)) > Number(0)) {
                                    disabled = false;
                                }
                                else {
                                    disabled = true;
                                    title = title + " (SOLD OUT)"
                                }
                            }
                        })
                        // filtering already registered dropdown items 
                        var options = [];
                        if (selectedmultiplevalues.includes(title)) {

                            title = title + " (Purchased)"
                            options = { value: dropdownoption, label: title, disabled: true, selected: true };
                            selecteditemnames.push(options);
                            //console.log(options);
                        }
                        else {
                            if (title.includes("SOLD OUT")) {
                                options = { value: dropdownoption, label: title, disabled: true };
                            }
                            else {
                                options = { value: dropdownoption, label: title };
                            }
                        }
                        //console.log(options);

                        return options;
                    })

                    return (
                        <Select
                            isMulti
                            className="basic-multi-select"
                            value={this.state.selectedregdropdownitem[item.name]}
                            options={dropdownItems}
                            onChange={this.handleMultipleRegDropdown(item, groupname)}
                            isOptionDisabled={(option) => option.disabled}
                        />

                    )
                }
                // this is to handle regular dropdown
                else {
                    return regitems.map(regitem => {
                        if (regitem.includes(item.name)) {
                            return dropdownOptions.map(dropdownoption => {
                                var [title, id] = dropdownoption.split("==")
                                var amount = item.amount;

                                var result = false;
                                global.$regsubitems.map(subitem => {
                                    if (subitem.data5 == id && subitem.data3 == "dropdownprice") {
                                        amount = subitem.amount;
                                        result = true;
                                    }
                                })
                                if (result = false) {
                                    amount = item.amount;
                                }
                                return (
                                    <div>
                                        {
                                            regitem == item.name + " - " + title + " - $" + amount ?
                                                (

                                                    <div className="regoption-dropdown-div">
                                                        {/*<Label for="label" className="payment-dropdown-label" style={global.$registrationform.styles.paymentmethod.fieldlabel}>{question.title}</Label>*/}
                                                        <Input type="select" className="form-control" id="regoption_dropdown_item" name="selectedregdropdownitem" value={title} onChange={this.handleRegDropdown(item, groupname)} disabled>
                                                            <option key={title} value={dropdownoption} className="reg-dorpdown-item">{title}</option>
                                                        </Input>
                                                    </div>
                                                )
                                                :
                                                (
                                                    ''
                                                )
                                        }
                                    </div>
                                )

                            })
                        }
                    })
                }
            }
            // this is for update and not registered for this item
            else {
                return (
                    this.renderRegDropdownOptions(item, groupname)
                )
            }
        }
    }

    renderRegDropdownOptions(regitem, groupname) {
        var array = regitem.data2.split("~~"); 
        //console.log(array);

        let dropdownItems = array.map((itemname) => {
            var [title, id] = itemname.split("==")
            var disabled = false;
            //console.log(title, id)

            // Using this variable to check that reopdown items are available or soldout
            global.$regsubitems.map(dropdownitem => {
                //console.log(dropdownitem);
                if (dropdownitem.name == title && dropdownitem.data5 == id) {
                    var maxsignups = dropdownitem.maxsignups;
                    var currentsignups = dropdownitem.currentsignups;

                    if ((Number(maxsignups) - Number(currentsignups)) > Number(0)) {
                        disabled = false;
                    }
                    else {
                        disabled = true;
                        title = title + " (SOLD OUT)"
                    }
                }
            })

            if (regitem.data4 == "multiselect") {
                var options = []
                if (title.includes("SOLD OUT")) {
                    options = { value: itemname, label: title, disabled: true }
                }
                else {
                    options = { value: itemname, label: title }
                }

                return options;
            }
            else {
                return (<option key={itemname} value={itemname} disabled={disabled} className="reg-dorpdown-item">{title}</option>)
            }

        });
        //console.log(optionObjs)

        // syles for the multi select dropdown
        const styles = {
            menu: base => ({
                ...base,
                marginTop: 0
            })
        };
        if (regitem.data4 == "multiselect") {
            return (
                <Select
                    isMulti
                    className="basic-multi-select"
                    value={this.state.selectedregdropdownitem[regitem.name]}
                    options={dropdownItems}
                    onChange={this.handleMultipleRegDropdown(regitem, groupname)}
                    isOptionDisabled={(option) => option.disabled}
                    styles={styles} />
            )
        }
        else {
            return (
                <Input type="select" className="registrationform-dropdown" id="regoption_dropdown_item" name="selectedregdropdownitem" value={this.state.selectedregdropdownitem[regitem.name]} onChange={this.handleRegDropdown(regitem, groupname)}>
                    {dropdownItems}
                </Input>
            )
        }

    }
    renderSignupsRemaining(signupsremaining) {
        return (
            <div className="reg-signups-remaining">{signupsremaining}</div>
        )
    }

    handleRegDropdown = (selected, groupname) => (event) => {

        global.$regitems.map((regitem) => {
            //filtering the reg item(by group, inputtype and name) from array and updating its status
            if (regitem.groupname == groupname) {
                if (regitem.data5 == selected.data5) {
                    var [value, id] = event.target.value.split("==");

                    // selected values from dropdown should not be empty or Select(default value as first item) 
                    if (event.target.value != "Select" && event.target.value != "" && event.target.value != " ") {

                        // using this variable to tell from which reg item to take the price
                        var result = false;

                        global.$regsubitems.map(subitem => {

                            // filtering the sub item and updating its atatus and getting amount from sub item
                            if (subitem.data5 == id && subitem.data3 == "dropdownprice") {

                                regitem.isChecked = true;
                                regitem.itemname = regitem.name + " - " + value;
                                regitem.itemid = id;
                                regitem.dropdownvalue = value;
                                regitem.itemprice = subitem.amount;
                                this.setState({ selectedregdropdownitem: value });

                                result = true;
                            }
                        })

                        // using this to take the amount from main reg item
                        if (result == false) {
                            regitem.isChecked = true;
                            regitem.itemname = regitem.name + " - " + value;
                            regitem.itemid = id;
                            regitem.dropdownvalue = value;
                            regitem.itemprice = regitem.amount;
                            this.setState({ selectedregdropdownitem: value });
                        }
                    }
                    else {
                        regitem.isChecked = false;
                        regitem.itemname = "";
                        regitem.itemid = "";
                        regitem.dropdownvalue = "";
                        regitem.itemprice = "0";
                        this.setState({ selectedregdropdownitem: value });
                    }
                }
            }
        })
        this.props.refreshComponent();
    }
    handleMultipleRegDropdown = (selected, groupname) => (event) => {

        global.$regitems.map((regitem) => {
            //filtering the reg item(by group, inputtype and name) from array and updating its status
            if (regitem.groupname == groupname) {
                if (regitem.data5 == selected.data5) {
                    var selecteddropdownoptions = [];
                    var selecteddropdownitemprice = 0;
                    var selecteddropdownoptionids = [];

                    event.map(eventvalue => {   // selection loop
                        var [value, id] = eventvalue.value.split("==")

                        // selected values from dropdown should not be empty or Select(default value as first item) 
                        if (value != "Select") {

                            // using this variable to tell from which reg item to take the price
                            var result = false;

                            global.$regsubitems.map(subitem => {

                                // filtering the sub item and updating its atatus and getting amount from sub item
                                if (subitem.data5 == id) {
                                    selecteddropdownoptions.push(value);
                                    selecteddropdownoptionids.push(id);
                                    selecteddropdownitemprice = Number(selecteddropdownitemprice) + Number(subitem.amount);
                                    result = true;
                                }
                            })
                            // using this to take the amount from main reg item
                            if (result == false) {
                                selecteddropdownoptions.push(value);
                                selecteddropdownoptionids.push(id);
                                selecteddropdownitemprice = Number(selecteddropdownitemprice) + Number(regitem.amount);
                            }
                        }
                    })
                    //console.log(selecteddropdownoptions)

                    // Updating the main reg item with all the seleted dropdown items 
                    if (selecteddropdownoptions.length != 0) {
                        regitem.isChecked = true;
                        selecteddropdownoptions = selecteddropdownoptions.toString();
                        selecteddropdownoptions = selecteddropdownoptions.replace(/,/g, " - ");
                        regitem.itemname = regitem.name + " - " + selecteddropdownoptions;
                        regitem.itemid = selecteddropdownoptionids.toString();
                        regitem.dropdownvalue = selecteddropdownoptions;
                        regitem.itemprice = selecteddropdownitemprice.toString();
                    }
                    else {
                        regitem.isChecked = false;
                        // item.data3 = "";
                        regitem.itemname = "";
                        regitem.itemid = "";
                        regitem.dropdownvalue = "";
                        regitem.itemprice = "0";
                    }
                }

            }
        })
        this.props.refreshComponent();
    };
}

export default RegItemdropdown;